import React from "react";
import PropTypes from "prop-types";
import Icon from "../Icon";
import { UiFilterBar, UiSearchInput, UiFilterCondition } from "./FilterBar.style";
/**
 * 篩選bar
 */

const FilterBar = ({
  onChange,
  children,
  prevChildren
}) => {
  return /*#__PURE__*/React.createElement(UiFilterBar, null, prevChildren, /*#__PURE__*/React.createElement(UiSearchInput, null, /*#__PURE__*/React.createElement(Icon, {
    name: "search",
    color: "#fff"
  }), /*#__PURE__*/React.createElement("input", {
    type: "text",
    placeholder: "\u641C\u5C0B...",
    onChange: e => onChange(e.target.value)
  })), /*#__PURE__*/React.createElement(UiFilterCondition, null, children));
};

export default FilterBar;
FilterBar.propTypes = {
  onChange: PropTypes.func,
  children: PropTypes.node,
  prevChildren: PropTypes.node
};